/**
 * "Hace 5 min" / "Hace 2 h". Vive aqui porque lo usan la tarjeta y el
 * hilo de respuestas, y dos copias de la misma cuenta de minutos
 * divergen en cuanto alguien las toca.
 */
export function tiempoRelativo(iso: string): string {
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return '';

  const minutos = Math.floor((Date.now() - fecha.getTime()) / 60000);

  if (minutos < 1) return 'ahora mismo';
  if (minutos < 60) return `hace ${minutos} min`;

  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `hace ${horas} h`;

  const dias = Math.floor(horas / 24);
  if (dias < 7) return `hace ${dias} días`;

  return fecha.toLocaleDateString('es-CO', { day: 'numeric', month: 'short' });
}
